module.exports = __webpack_public_path__ + "img/github2.12f30826.png";